import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function locationReducer(state = initialState.locationState, action) {
    switch(action.type) {
        case types.GET_COUNTRIES:   
        {        
            const countries = action.countries;
            return {
                ...state,
                countries
            };
        }
        default:
            return state;
    }
}